import { Row, Col, Label, Input } from "reactstrap";

// Tester request (2026-10-01):
//   • the ECN Title is the title of the document (legacy copied it into the
//     Document Title on every keystroke; the separate Document Title field is
//     gone from the ECN form, see CreateEcn / DmsFormLayout);
//   • the two customer check boxes sit together under one label,
//     "Check Box If Applicable".
const EcnHeaderTab = ({ data, update }) => {

    return (
        <>
            <Row className="mb-3">
                <Col md={8}>
                    <Label for="ecn-title">ECN Title</Label>
                    <Input
                        id="ecn-title"
                        value={data.title || ""}
                        placeholder="Enter a descriptive title for this ECN"
                        onChange={(e) =>
                            update("title", e.target.value)
                        }
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={4}>
                    <Label for="ecn-date-needed">Date Needed</Label>
                    <Input
                        id="ecn-date-needed"
                        type="date"
                        value={data.dateNeeded || ""}
                        onChange={(e) =>
                            update("dateNeeded", e.target.value)
                        }
                    />
                </Col>

                <Col md={8}>
                    <Label className="fw-semibold">Check Box If Applicable</Label>
                    <div className="border rounded p-3 bg-light-subtle">
                        <div className="form-check mb-2">
                            <Input
                                type="checkbox"
                                id="ecn-customer-approval-required"
                                checked={data.customerApprovalRequired || false}
                                onChange={(e) =>
                                    update("customerApprovalRequired", e.target.checked)
                                }
                            />
                            <Label className="form-check-label" for="ecn-customer-approval-required">
                                Customer Approval Required
                            </Label>
                        </div>
                        <div className="form-check">
                            <Input
                                type="checkbox"
                                id="ecn-customer-notification-required"
                                checked={data.customerNotificationRequired || false}
                                onChange={(e) =>
                                    update("customerNotificationRequired", e.target.checked)
                                }
                            />
                            <Label className="form-check-label" for="ecn-customer-notification-required">
                                Customer Notification Required
                            </Label>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default EcnHeaderTab;
